
import { defineComponent, computed, PropType } from 'vue'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiChevronDown } from '@mdi/js'
import { SelectOptions } from '@/types/forms/select'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    selectedVal: {
      'default': () => (undefined),
    },
    options: {
      type: Array as PropType<SelectOptions[]>,
      'default': () => ([]),
    },
  },
  emits: ['update:selectedVal'], //https://vuejs.org/guide/components/events.html#v-model-arguments
  setup(props, context) {
    const selected = computed({
      get() {
        return props.selectedVal
      },
      set(value) {
        context.emit('update:selectedVal', value)
      }
    })

    return {
      mdiChevronDown,
      selected
    }
  },
})
